import React from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthService } from '../Service/auth'
import Login from '../Components/Login'
import { auth } from './../store/auth'
import { toast } from 'react-toastify'

export default function LoginContainer() {
	const navigate = useNavigate()
	const [isShowPassword, setIsShowPassword] = React.useState(false)
	const [isLoader, setIsLoader] = React.useState(false)
	const [form, setForm] = React.useState({
		login: '',
		password: ''
	})

	const changeShowPassword = () => setIsShowPassword(pre => (pre = !pre))

	const change = e => setForm(pre => (pre = { ...pre, [e.target.name]: e.target.value }))

	const handleLogin = async e => {
		try {
			e.preventDefault()
			const login = form.login.trim()
			const password = form.password.trim()
			if (login.length && password.length) {
				setIsLoader(true)
				auth.newUser({ isAuthenticated: false, data: null, isLoading: false })
				const { data, message, token } = await AuthService.login({ login, password })
				setIsLoader(false)
				if (!token.length) {
					return toast.warn(message)
				}
				auth.newUser({ isAuthenticated: true, data: data, isLoading: false })
				navigate('/bt/students')
				return
			}
			toast.warn('Заполните все поля!')
		} catch (e) {
			console.log(e)
		}
	}

	if (!auth.user.isLoading && auth.user.isAuthenticated) {
		navigate(`/bt/students`)
	}

	return (
		<>
			<Login
				login={form.login}
				password={form.password}
				handleLogin={handleLogin}
				change={change}
				isLoader={isLoader}
				isShowPassword={isShowPassword}
				changeShowPassword={changeShowPassword}
			/>
		</>
	)
}
